import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const nav = [
  { to: "/", label: "Home" },
  { to: "/category", label: "Categories" },
  { to: "/location", label: "Locations" },
  { to: "/blog", label: "Guides" },
  { to: "/about", label: "About" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/85 backdrop-blur-md">
      <div className="container mx-auto flex h-24 items-center justify-between px-4">
        <div className="flex flex-1 items-center justify-start">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="LetsListBusiness"
              className="h-56 w-auto object-contain -ml-6"
            />
          </Link>
        </div>

        <nav className="hidden items-center gap-7 md:flex">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="text-lg font-medium text-muted-foreground transition-colors hover:text-foreground"
              activeProps={{ className: "text-foreground" }}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden flex-1 items-center justify-end gap-3 md:flex">
          <Link
            to="/login"
            className="text-lg font-medium text-muted-foreground hover:text-foreground"
          >
            Log in
          </Link>
          <Link
            to="/add-business"
            className="inline-flex items-center justify-center rounded-full bg-foreground px-4 py-2 text-lg font-semibold text-background transition-transform hover:scale-[1.02]"
          >
            Add a business
          </Link>
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border md:hidden">
          <div className="container mx-auto flex flex-col gap-1 px-4 py-3">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground hover:bg-muted"
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/login"
              onClick={() => setOpen(false)}
              className="rounded-md px-3 py-2 text-sm font-medium hover:bg-muted"
            >
              Log in
            </Link>
            <Link
              to="/add-business"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-foreground px-3 py-2 text-center text-sm font-semibold text-background"
            >
              Add a business
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
